<template>
  <template v-if="queries.orderStatuses.isLoading">
    <fullscreen-loader />
  </template>

  <template v-else-if="queries.orderStatuses.isError">
    <api-error :error="queries.orderStatuses.error" />
  </template>

  <template v-else-if="queries.orderStatuses.isSuccess">
    <router-view v-slot="{ Component }">
      <at-sidebar
        :items="items"
        :logo="{
          name: 'Merchant Logo',
          path: '/Logo.svg',
          darkPath: '/LogoDark.svg',
        }"
        :module="module"
        :modules="moduleOptions"
        @update:module="changeModule"
      >
        <template #user-section>
          <profile-settings />
        </template>

        <template #default>
          <div class="pb-12 -m-6">
            <component :is="Component"></component>
          </div>
        </template>
      </at-sidebar>
    </router-view>
  </template>

  <reload-page-on-deploy-modal />
</template>

<script setup>
  import { computed, reactive } from 'vue';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { useMainStore } from '@/to-fsd/shared/store/main';
  import { storeToRefs } from 'pinia';
  import { ALIFSHOP_ROUTE_NAMES as ALIFSHOP_ROUTES } from '@/to-fsd/shared/router';
  import { useModuleOptions } from '@/to-fsd/shared/hooks';
  import { useJivoFieldsAutoComplete } from '@/to-fsd/features/jivo';
  import { ReloadPageOnDeployModal } from '@/to-fsd/features/reload-page-on-deploy';
  import { FullscreenLoader } from '@/to-fsd/shared/ui';
  import { useGetOrderStatusesQuery } from '@/to-fsd/shared/queries';
  import { ApiError } from '@/to-fsd/shared/api';
  import { AtSidebar } from '@packages/aliftech-ui';
  import { modulesList, modulesName } from '@/to-fsd/shared/constants';
  import { ProfileSettings } from '@/to-fsd/widgets/profile-settings';

  const queries = reactive({
    orderStatuses: useGetOrderStatusesQuery(),
  });

  useJivoFieldsAutoComplete();

  const { t } = useI18n();
  const router = useRouter();

  const store = useMainStore();

  const { module } = storeToRefs(store);
  const moduleOptions = useModuleOptions();

  store.$patch({ module: modulesName.ALIFSHOP });

  const links = computed(() => {
    return [
      {
        title: t('layouts.alifshop.orders'),
        visible: true,
        icon: 'ShoppingCart',
        to: { name: ALIFSHOP_ROUTES.ordersList },
      },
    ];
  });

  const items = computed(() => {
    return links.value?.filter?.(link => {
      return link.visible || false;
    });
  });

  const changeModule = value => {
    store.$patch({ module: value });
    router.push({ name: modulesList[value].homeRoute });
  };
</script>
